export const BeltSelectOptions = [
  {
    label: "10. Gup",
    value: "10-gup",
  },
  {
    label: "9. Gup",
    value: "9-gup",
  },
  {
    label: "8. Gup",
    value: "8-gup",
  },
  {
    label: "7. Gup",
    value: "7-gup",
  },
  {
    label: "6. Gup",
    value: "6-gup",
  },
  {
    label: "5. Gup",
    value: "5-gup",
  },
  {
    label: "4. Gup",
    value: "4-gup",
  },
  {
    label: "3. Gup",
    value: "3-gup",
  },
];

export const LanguageSelectOptions = [
  {
    label: "Koreansk til norsk",
    value: "koreanToNorwegian",
  },
  {
    label: "Norsk til koreansk",
    value: "norwegianToKorean",
  },
];
